export default "/static/dashboard/build/app/img/v2/85f0da04e838274bbb37476bf4140244.png";